import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PopUpBusyComponent } from '../Components/ErrorPopUp/PopUpBusyComponent';
import { AppInjector } from './AppInjector';

export abstract class BaseBusyableComponent {

	private busymodalService: NgbModal

	constructor() {
		this.busymodalService = AppInjector.get(NgbModal);
	}

	onSort(newCriteria: ePM.Logic.SortCriteria) {
		this.sortCriteria = newCriteria;
	}

	sortCriteria: ePM.Logic.SortCriteria;

	private _isSaving: boolean = false;

	private timer: any = null;

	get isSaving(): boolean {
		return this._isSaving;
	}

	set isSaving(val: boolean) {
		if (this._isSaving != val) {
			this._isSaving = val;
			if (val) {
				this.startBusyTimer();
			} else {

				this.hideBusyModal();
			}
		}
	}

	public arrayCount(n: number): any[] {
		return new Array(n).fill('', 0, n - 1);
	}

	cancelBusyOperation() {
		this.hideBusyModal();
	}
	private busymodal: NgbModalRef = null;
	startBusyTimer() {
		var thisHolder = this;
		thisHolder.timer = setTimeout(function () {
			thisHolder.busymodal = thisHolder.busymodalService.open(PopUpBusyComponent);
			thisHolder.busymodal.result.then((result: boolean) => {
				if (result) {
					thisHolder.cancelBusyOperation();
				}
			}, (reason) => {

			});
		}, 2000);
	}
	hideBusyModal() {
		clearTimeout(this.timer);
		if (this.busymodal) {
			this.busymodal.close();
		}
	}

	getErrorsFromResponse(error: any): string[] {
		if ("string" == typeof (error)) {
			try {
				error = JSON.parse(error);
			} catch{ }
		}
		var errors = [];
		if (error.error) {
			error = error.error;
		}
		if (error.ModelState) {
			var modelState = error.ModelState;
			for (var key in modelState) {
				if (modelState.hasOwnProperty(key)) {
					errors.push(modelState[key][0]);//list of error messages in an array
				}
			}
		} else {
			if (error.Message) {
				errors.push(error.Message);
			} else if (error.message) {
				errors.push(error.message);
			} else {
				errors.push('Error');
			}
		};
		return errors;
	}
}